import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { usePermission } from '@/hooks/usePermission';
import AccessDenied from './AccessDenied';

interface ProtectedRouteProps {
  permission?: string;
}

export default function ProtectedRoute({ permission }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((s) => s.accessToken !== null && s.user !== null);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();
  const hasPermission = usePermission(permission ?? '');

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user?.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }

  if (permission && !hasPermission) {
    return <AccessDenied />;
  }

  return <Outlet />;
}
